import {
  Error,
  ADD_Holiday,
  UPDATE_Holiday,
  DELETE_Holiday,
  GET_Holiday,
} from "../type";
const initialState = {
  AddHoliday: [],
  GetHoliday: [],
  UpdateHoliday: [],
  DeleteHoliday: [],
};
const HolidayR = (state = initialState, action) => {
  switch (action.type) {
    case GET_Holiday:
      return {
        ...state,
        GetHoliday: action.payload,
      };
    case ADD_Holiday:
      return {
        GetHoliday: state.GetHoliday,
        AddHoliday: action.payload,
      };
    case UPDATE_Holiday:
      return {
        GetHoliday: state.GetHoliday,
        UpdateHoliday: action.payload,
      };
    case DELETE_Holiday:
      return {
        GetHoliday: state.GetHoliday,
        DeleteHoliday: action.payload,
      };
    case Error:
      return {
        GetHoliday: action.payload,
      };
    default:
      return state;
  }
};
export default HolidayR;
